export const
    SetTheme: ISetThemeActionCreator = (light) => {
        return {
            type: ACTION_SET_THEME,
            light
        }
    },

    Clear: IThemeClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_THEME_CLEAR,
            propertiesToClear
        }
    };



export const
    ACTION_SET_THEME = "ACTION_SET_THEME",

    ACTION_THEME_CLEAR = "ACTION_THEME_CLEAR";

export interface ISetThemeAction {
    type: "ACTION_SET_THEME";
    light: boolean;
}

export interface ISetThemeActionCreator {
    (light: boolean): ISetThemeAction;
}

export interface IThemeClearAction {
    type: "ACTION_THEME_CLEAR";
    propertiesToClear?: string[];
}

export interface IThemeClearActionCreator {
    (propertiesToClear?: string[]): IThemeClearAction;
}

export type ThemeAction =
    ISetThemeAction |
    IThemeClearAction;
